import { render, staticRenderFns } from "./CompletionMessage.vue?vue&type=template&id=6c4037a6"
import script from "./CompletionMessage.vue?vue&type=script&lang=js"
export * from "./CompletionMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports